// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import './index.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import { Provider } from 'react-redux';
import './i18n';
import { PersistGate } from 'redux-persist/integration/react';
import {persistor} from '../src/store/store';
import store  from '../src/store/store';


const children = (
	<AuthContextProvider>
		<ThemeContextProvider>
			<Router>
					<Provider store={store}>
						<PersistGate  persistor={persistor}>
							<App/>
						</PersistGate>
					</Provider>
			</Router>		
		</ThemeContextProvider>
	</AuthContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
